<template>
  <stats-card v-loading="loading" title="Total de clientes" type="success" class="mb-0" :sub-title="`${value}`" icon="ni ni-single-02">
  </stats-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data(){
    return {
      value: '',
      loading: false
    }
  },
  computed: {
    ...mapState('client',['totalClients'])
  },
  methods: {
    ...mapActions('client',['getTotalClients'])
  },
  async mounted() {
    this.loading = true
    await this.getTotalClients()
    this.loading = false
    this.value = this.totalClients ? `${this.totalClients}` : '0'
  }
}
</script>

<style scoped>

</style>